/**
 * Created by Moment on 2017/5/8.
 * 时间日期相关的工具类函数
 */

/**
 * 得到固定时间戳
 * @param day  2015-02-03 10:00:00
 * @returns {number}
 */
export const getTimeByTimeString = function (day) {
  var re = /(\d{4})(?:-(\d{1,2})(?:-(\d{1,2}))?)?(?:\s+(\d{1,2}):(\d{1,2}):(\d{1,2}))?/.exec(day)
  return new Date(re[1], (re[2] || 1) - 1, re[3] || 1, re[4] || 0, re[5] || 0, re[6] || 0).getTime()
}

/**
 * 通过时间缀得到年，月,日
 * @param nS
 * @returns {string}
 */
export const getLocalTime = function (nS) {
  return new Date(parseInt(nS) * 1000).toLocaleString().replace(/:\d{1,2}$/, ' ')
}

/**
 * 把秒数转换成hh:mm:ss的形式
 * @param s
 * @returns {*}
 */
export const secondFormat = function (s) {
  if (s > 0) {
    return [
      Math.floor(s / 3600),
      Math.floor(s % 3600 / 60),
      Math.floor(s % 60)
    ].join(':').replace(/\d+/g, function (s) {
      return s.length == 1 ? '0' + s : s
    })
  }
  return '00:00:00'
}

export const secondFormat1 = function (s) {
  if (s > 0) {
    return [
      Math.floor(s / 3600),
      Math.floor(s % 3600 / 60),
      Math.floor(s % 60)
    ].join(':').replace(/\d+/g, function (s) {
      return s.length == 1 ? '0' + s : s
    })
  }
  return '00:00:00'
}

/**
 * 把秒数转换成 dd:hh:mm:ss的形式
 * @param s
 * @returns {string}
 */
export const secondFormatDay = function (intDiff) {
  if (intDiff > 0) {
    var day = Math.floor(intDiff / (60 * 60 * 24))
    var hour = Math.floor(intDiff / (60 * 60)) - (day * 24)
    var minute = Math.floor(intDiff / 60) - (day * 24 * 60) - (hour * 60)
    var second = Math.floor(intDiff) - (day * 24 * 60 * 60) - (hour * 60 * 60) - (minute * 60)
    return [
      day,
      hour,
      minute,
      second
    ].join(':').replace(/\d+/g, function (s) {
      return s.length == 1 ? '0' + s : s
    })
  }
  return '00:00:00:00'
}

/**
 * 通过年，月，得到当月天数
 * @param y
 * @param m
 * @returns {number}
 */
export const getDayNumByYearAMonth = function (y, m) {
  var year = y
  var month = m
  var day = 28
  switch (parseInt(month)) {
    case 1:
    case 3:
    case 5:
    case 7:
    case 8:
    case 10:
    case 12:
      day = 31
      break
    case 4:
    case 6:
    case 9:
    case 11:
      day = 30
      break
    case 2:
      if (year % 400 == 0 || (year % 100 != 0 && year % 4 == 0)) {
        day = 29
      }
      break
  }
  return day
}

export const subSting = function (text, num) {
  var subText = text
  if (text.length > num) {
    subText = text.substring(0, num) + '...'
  }
  return subText
}

/**
 * 判断是否为空
 * @param  {[type]}  obj [description]
 * @return {Boolean}     [description]
 */
export const isNullOrEmpty = function (obj) {
  if (obj === undefined || obj === null || obj === '' || obj === 0) {
    return true
  }
  return false
}

/**
 * Int数字格式化为时间格式
 * @param date
 * @param format
 * @returns {*}
 */
export const formatDate = function (date, format) {
  if (isNullOrEmpty(date)) {
    return ''
  }
  if (date.toString().length === 10) {
    date = new Date(parseInt(date) * 1000)
  } else {
    date = new Date(parseInt(date))
  }
  if (format === undefined) {
    format = 'yyyy-MM-dd hh:mm:ss'
  }
  var o = {
    'M+': date.getMonth() + 1, // month
    'd+': date.getDate(), // day
    'h+': date.getHours(), // hour
    'm+': date.getMinutes(), // minute
    's+': date.getSeconds(), // cond
    'q+': Math.floor((date.getMonth() + 3) / 3), // quarter
    'S': date.getMilliseconds() // millisecond
  }
  if (/(y+)/.test(format)) {
    format = format.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(format)) {
      format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length))
    }
  }
  return format
}

/**
 * 获取当前日期的前几天日期
 * @param  {[type]} interval [description]
 * @return {[type]}          [description]
 */
export const getPreDate = function (interval) {
  if (isNullOrEmpty(interval)) {
    interval = 0
  }
  var now = new Date()
  return formatDate(now.setDate(now.getDate() - interval), 'yyyy-MM-dd')
}

/**
 * 深复制clone对象
 * @param  {[Object]} obj [description]
 * @return {[Object]}     [description]
 */
export const getCloneObj = function (obj) {
  return JSON.parse(JSON.stringify(obj))
}

/**
 * 判断年份是否为润年
 *
 * @param {Number} year
 */
export function isLeapYear (year) {
  return (year % 400 == 0) || (year % 4 == 0 && year % 100 != 0)
}

/**
 * 获取某一年份的某一月份的天数
 *
 * @param {Number} year
 * @param {Number} month
 */
export function getMonthDays (year, month) {
  return [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month] || (isLeapYear(year) ? 29 : 28)
}

/**
 * 获取某个时间点在一年的第几周
 * @param date
 * @returns {number}
 */
export function getWeek (date) {
  if (!date) {
    date = new Date()
  }
  if (!(date instanceof Date)) {
    throw new TypeError('参数date必须为Date类型')
  }
  let year = date.getFullYear(),
    month = date.getMonth(),
    days = date.getDate()
  // 那一天是那一年中的第多少天
  for (var i = 0; i < month; i++) {
    days += getMonthDays(year, i)
  }

  // 那一年第一天是星期几
  var yearFirstDay = new Date(year, 0, 1).getDay() || 7

  var week = null
  if (yearFirstDay == 1) {
    week = Math.ceil(days / yearFirstDay)
  } else {
    days -= (7 - yearFirstDay + 1)
    week = Math.ceil(days / 7) + 1
  }

  return week
}

/**
 * 根据时间返回月、日信息,如{05.06}
 * @param date
 * @returns {string}
 */
export const getMonthDate = function (date) {
  if (!date) {
    date = new Date()
  }
  if (!(date instanceof Date)) {
    throw new TypeError('参数date必须为Date类型')
  }
  return `${date.getMonth() + 1}.${date.getDate()}`
}

/**
 * 转化饿了么时间组件v-model值为时间字符串方法
 * @param time
 * @returns {*}
 */
export const getTimeByDateStr = function (time, format) {
  if (!time) {
    return ''
  }
  return formatDate(new Date(time).getTime(), format)
}
